import ImageLogout from '@/assets/img/account-logout.svg';
import ModalDefault from '@/components/Modals/ModalDefault';
import { useSignout } from '@/hooks/useSignout';
import { Box, Button } from '@mui/material';

interface ILogoutModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const LogoutModal = ({ isOpen, onClose }: ILogoutModalProps) => {
  const { signout } = useSignout();

  return (
    <ModalDefault
      isOpen={isOpen}
      onClose={onClose}
      src={ImageLogout}
      alt="Imagem de ilustração para representa a desativação de conta"
      title="Deseja desconectar da conta?"
      subtitle="Você será desconectado e terá que efetuar o login novamente para ter acesso à plataforma."
    >
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button sx={{ mt: 2 }} variant="outlined" fullWidth onClick={onClose}>
          Voltar
        </Button>
        <Button
          sx={{ mt: 2 }}
          variant="contained"
          fullWidth
          onClick={() => {
            onClose();
            signout();
          }}
        >
          Desconectar
        </Button>
      </Box>
    </ModalDefault>
  );
};

export type { ILogoutModalProps };
